import { AxiosInstance } from 'axios';
import { classToPlain } from 'class-transformer';

import { Search, SortDirection } from '../models/search.model';
import { BaseService } from './base.service';

export class ListOptions {
	listname?: string;
	listitemname?: string;
	numitem?: number;
}

export class ListService extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	getListItemsBySlug(slug: string): Promise<any> {
		const lname = 'selist';
		const iname = 'selistitem';
		const numitem = 100;
		const search = new Search(`${iname} join ${lname} on ${lname}.id = ${iname}.lid`);
		search.addSimpleFilter(`${lname}.slug`, slug);
		search.setSortDirection(SortDirection.ASCENDING);
		search.setSortField('itemlabel');

		return this.http.post(`/ws/${iname}/advancedsearch/0/${numitem}`, classToPlain(search));
	}

}
